import React from "react";
import GlobalContextProvider from "./src/context/global-context-provider";
import "./src/style/global.css";
import ReactDOM from "react-dom/client";

/* FORCEFULLY REMOVE OLD SITE SERVICE WORKERS */
export const onServiceWorkerUpdateReady = () => {
  window.location.reload(true);
};

export const onClientEntry = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (let registration of registrations) {
        registration.unregister();
      }
    });
  }
};
/* END FORCEFULLY REMOVE OLD SITE SERVICE WORKERS */

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};

export const wrapRootElement = ({ element }) => {
  return <GlobalContextProvider>{element}</GlobalContextProvider>;
};
